import { render } from "./MapPage.vue?vue&type=template&id=d791f1dc"
import script from "./MapPage.vue?vue&type=script&lang=js"
export * from "./MapPage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__